import { PropsWithClassName } from "kz-ui-sdk";
import { PropsWithChildren, ReactNode } from "react";
import { NavigateOptions } from "react-router-dom";

export type OnboardLayoutVariant = "welcome" | "standard";

export interface NavigationConfig {
  back?: {
    url?: string;
    onClick?: () => void;
    options?: NavigateOptions;
  };
  close?: {
    url?: string;
    onClick?: () => void;
    options?: NavigateOptions;
  };
}

export interface UIFeatures {
  showBackButton?: boolean;
  showCloseButton?: boolean;
  showChatButton?: boolean;
  showLanguageSelect?: boolean;
}

export interface TransitionConfig {
  enableRevealAnimation?: boolean;
}

export interface OnboardLayoutProps extends PropsWithChildren, PropsWithClassName {
  title?: string | ReactNode;
  subTitle?: string | ReactNode;
  variant?: OnboardLayoutVariant;
  navigation?: NavigationConfig;
  features?: UIFeatures;
  transitions?: TransitionConfig;
  contentClassName?: string;
}

export const DEFAULT_FEATURES: Required<UIFeatures> = {
  showBackButton: false,
  showCloseButton: false,
  showChatButton: false,
  showLanguageSelect: false,
};

export const DEFAULT_TRANSITIONS: Required<TransitionConfig> = {
  enableRevealAnimation: false,
};
